import * as Ionic from '@ionic/vue'
import * as appComponents from '@/components/index.js'
import * as appLayouts from '@/layout/index.js'

import { IonicVue } from '@ionic/vue'
import { Field, Form, ErrorMessage, configure } from 'vee-validate'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css'
import '@ionic/vue/css/float-elements.css'
import '@ionic/vue/css/text-alignment.css'
import '@ionic/vue/css/text-transformation.css'
import '@ionic/vue/css/flex-utils.css'
import '@ionic/vue/css/display.css'
/* Theme variables */
import '@/sass/theme/variables.scss'
import '@/sass/theme/core.scss'

export default (app) => {
  app.use(IonicVue)
  const ionicKeys = Object.keys(Ionic)
  ionicKeys.forEach(key => {
    if (/^Ion/.test(key)) {
      app.component(key, Ionic[key])
    }
  })

  configure({
    validateOnBlur: true, // controls if `blur` events should trigger validation with `handleChange` handler
    validateOnChange: false, // controls if `change` events should trigger validation with `handleChange` handler
    validateOnInput: false, // controls if `input` events should trigger validation with `handleChange` handler
    validateOnModelUpdate: false, // controls if `update:modelValue` events should trigger validation with `handleChange` handler
  })

  app.component('Form', Form)
  app.component('Field', Field)
  app.component('ErrorMessage', ErrorMessage)


  const appComponentsKeys = Object.keys(appComponents)
  appComponentsKeys.forEach(key => {
    app.component(key, appComponents[key])
  })

  const appLayoutsKeys = Object.keys(appLayouts)
  appLayoutsKeys.forEach(key => {
    app.component(key, appLayouts[key])
  })
}